import React from "react";
import { WizTableForm } from '@/containers/common'
const exam = WizTableForm.Config.exam(this, { apiParams: { } })
const organization = { allowTreeSelect: true , ...WizTableForm.Config.organization(this)}
import moment from "moment";
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
//配置项
const componentName = "examReport";

function columns() {
  return [
    {
      name: "id",
    },
    {
      title: "考试名称",
      name: "title",
      tableItem: {},
    },
    {
      title: "考试名称",
      name: "examId",
      searchItem: {
        ...exam,
        diy: WizTableForm,
        selectType: 'radio',
        rules: [
          {
            required: true,
            message: '请选择考试名称'
          }
        ]
      },
    },
    {
      title: "组织名称",
      name: "orgIds",
      searchItem: {
        ...organization,
        diy: WizTableForm,
        onChangeRowMap: (e) => {},
      },
    },
    {
      title: "考试分类",
      name: "examCategoryName",
      tableItem: {},
    },
    {
      title: '考试类型',
      name: 'examType',
      tableItem: {
        render: (text, record) => {
          if(text==='0') {
            return '独立考试'
          } else if (text==='1'){
            return '课程考试'
          } else {
            return '独立考试、课程考试'
          }
        }
      },
    },
    {
      title: '考试状态',
      name: 'status',
      dict: [
        { code: 0, codeName: '草稿' },
        { code: 1, codeName: '已发布' },
        { code: 2, codeName: '已关闭' }
      ],
      tableItem: {},
      searchItem: {
        type: 'select'
      }
    },
    {
      title: '考试时间',
      name: 'examDate',
      dataIndex: "examDate",
      searchItem: {
        type: 'date~',
        showTime: true
      },
    },
    {
      title: "考试开始时间",
      name: "startDate",
      tableItem: {
        render: (text) => {
          return formatterDate(text)
        }
      },
    },
    {
      title: "考试结束时间",
      name: "endDate",
      tableItem: {
        render: (text) => {
          return formatterDate(text)
        }
      },
    },
    {
      title: '考试类型',
      name: 'examType',
      searchItem: {
        type: 'select',
      },
      dict: [
        { code: '0', codeName: '独立考试' },
        { code: '1', codeName: '课程考试' },
      ]
    },
    {
      title: "上级组织",
      name: "leadName",
      tableItem: {},
    },
    {
      title: "组织名称",
      name: "orgName",
      tableItem: {},
    },
    {
      title: "省份",
      name: "province",
      tableItem: {},
    },
    {
      title: "组织编码",
      name: "orgCode",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "orgTypeName",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "nodeCategoryIds",
      dict: {
        wizReplaceData: "orgNodeCategoryTree",
        defalutType: []
      },
      searchItem: {
        type: 'treeselect',
        treeCheckable: true
      }
    },
    {
      title: "应参考人数",
      name: "shoudCount",
      tableItem: {},
    },
    {
      title: "已参考人数",
      name: "factCount",
      tableItem: {},
    },
    {
      title: "参考率",
      name: "rate",
      tableItem: {
        render: text => text + '%'
      },
    },
    {
      title: "已通过人数",
      name: "passCount",
      tableItem: {},
    },
    {
      title: "通过率",
      name: "passRate",
      tableItem: {
        render: text => text + '%'
      },
    },
    {
      title: "省份",
      name: "province",
      searchItem: {}
    },
    {
      title: "未参考人数",
      name: "notCount",
      tableItem: {},
    },
    {
      title: "参考人次",
      name: "factNumber",
      tableItem: {},
    },
    {
      title: "平均分",
      name: "avgScore",
      tableItem: {},
    },
    {
      title: "最高分",
      name: "maxScore",
      tableItem: {},
    },
    {
      title: "最低分",
      name: "minScore",
      tableItem: {},
    },
    {
      title: "试题数量",
      name: "questionTotal",
      tableItem: {},
    },
  ];
}

function templateConfig() {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns.call(this),
        searchBarProps: {
          buttonSort:['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams:(rows,record,filters,callback)=>{
                  return {...filters}
                }
              }
            }
          ],
          dataFormat: (v) => {
            let value = Object.assign({}, v)
            if (value['nodeCategory'] && value['nodeCategory'].length) {
              value['nodeCategoryIds'] = value['nodeCategory'].map(nodeCategory => nodeCategory.value)
            } else {
              value['nodeCategoryIds'] = undefined
            }
            return value
          },
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            if (value.examDate && value.examDate.length === 2) {
              value.startDate = value.examDate[0].format('YYYY-MM-DD HH:mm:ss')
              value.endDate = value.examDate[1].format('YYYY-MM-DD HH:mm:ss')
            }
            return value
          },
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: (record, index) => index,
          isScroll: true,
          loading: false,
        }
      },
    },
  };
}

const apis = {
  list: {
    path: `${componentName}/getPageListOrg`,
    payload: {
      key: `${componentName}@getPageListOrg`,
      apiParams: { pageNum: 1, pageSize: 10 },
    },
  },
  export: {
    path: `${componentName}/exportOrg`,
    payload: {
      key: `${componentName}@exportOrg`,
      apiParams: {}
    }
  },
  orgNodeCategoryTree: {
    path: `organizationNodeCategory/getTypeNodeList`,
    payload: {
      key: `organizationNodeCategory@getTypeNodeList`,
      apiParams: {}
    }
  },
};

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ["list", "orgNodeCategoryTree"],
    needLoading: true,
    ...args,
  };
};

export { reduxTemplateCofig, templateConfig };
